var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"flash-modal t-flash-modal",attrs:{"value":true,"type":_vm.type},domProps:{"innerHTML":_vm._s(_vm.modal.data.message)}})
}
var staticRenderFns = []

export { render, staticRenderFns }